var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"msg-link",class:_vm.disabled? 'disabled' : '',on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.link.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }